import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { ReportRequest } from '../models/report.model';
import { SurveyPerformanceFilters } from '../models/survey-performance-report.model';
import {
  ReportActions,
  SurveyPerformanceReportActions,
} from './actions/report.actions';

@Injectable({ providedIn: 'root' })
export class ReportActionsFacade {
  private readonly _store = inject(Store);

  public loadReports(userId: number): void {
    this._store.dispatch(ReportActions.loadReports({ userId }));
  }

  public loadStatuses(): void {
    this._store.dispatch(ReportActions.loadStatuses());
  }

  public requestReport(request: ReportRequest): void {
    this._store.dispatch(ReportActions.requestReport({ request }));
  }

  public downloadReport(filename: string, fileType: string): void {
    this._store.dispatch(ReportActions.downloadReport({ filename, fileType }));
  }

  public downloadUserActivityReport(): void {
    this._store.dispatch(ReportActions.downloadUserActivityReport());
  }

  public loadSurveyPerformanceBuyers(): void {
    this._store.dispatch(SurveyPerformanceReportActions.loadBuyers());
  }

  public loadSurveyPerformanceResults(filters: SurveyPerformanceFilters): void {
    this._store.dispatch(
      SurveyPerformanceReportActions.loadResults({ filters }),
    );
  }
}
